<template>

    <div class="saque flex flex-col h-full ">
      <div class="flex-1 flex flex-col overflow-y-auto">
        <!-- <LoginPw
          v-if="step === 1"
          @setLoginPassword="setLoginPassword"
          @next="step = 2"
        /> -->
        <SaquePw v-if="step === 2" @next="step = 3" />
        <SetSuccess v-if="step === 3"></SetSuccess>
      </div>
    </div>
</template>

<script setup lang="ts">
import SaquePw from "./compontents/SaquePw.vue";
import SetSuccess from "./compontents/SetSuccess.vue";

const step = ref<number>(2);
</script>

<style lang="scss" scoped></style>
